import { Button, EmptyState, ErrorState, Icon } from '@lia/ui';
import { SearchRemoveIcon } from '@hugeicons/core-free-icons';
import { isRouteErrorResponse, Link, useRouteError } from 'react-router';
import { usePageTitle } from '../app/title.js';

export function NotFoundPage() {
  usePageTitle('Página no encontrada');
  return (
    <div className="grid min-h-[60dvh] place-items-center p-4">
      <EmptyState
        icon={<Icon icon={SearchRemoveIcon} aria-hidden />}
        title="No encontramos esta página"
        description="Revisa la dirección o vuelve al inicio."
        action={
          <Button asChild variant="secondary">
            <Link to="/">Ir al inicio</Link>
          </Button>
        }
      />
    </div>
  );
}

export function RouteErrorPage() {
  const error = useRouteError();
  usePageTitle('Error');
  if (isRouteErrorResponse(error) && error.status === 404) return <NotFoundPage />;
  // A failed lazy chunk (e.g. after a deploy) is fixed by reloading.
  const chunk = error instanceof Error && /dynamically imported module|Failed to fetch/i.test(error.message);
  return (
    <div className="grid min-h-dvh place-items-center bg-surface-canvas p-4">
      <ErrorState
        title={chunk ? 'Hay una versión nueva de la aplicación' : 'Algo salió mal en esta pantalla'}
        description={chunk ? 'Recarga la página para continuar.' : 'Recarga la página. Si el problema continúa, avisa a soporte.'}
        action={
          <>
            <Button onClick={() => window.location.reload()}>Recargar</Button>
            <Button asChild variant="secondary">
              <Link to="/">Ir al inicio</Link>
            </Button>
          </>
        }
      />
    </div>
  );
}
